import type { StudentPortfolioTaskResource } from "api/generated";
import type { StudentPortfolioTask } from "portfolio/types";
import { mapAttachment } from "shared/mappers";
import { mapLinks } from "shared/mappers/link.mapper";
import { mapVideos } from "shared/mappers/video.mapper";
import { studentSkillFromDto } from "./skill.mapper";
import { studentTagFromDto } from "./tag.mapper";
import { taskQuestionFromDto } from "./taskQuestion.mapper";

export const portfolioStudentTaskFromDto = (
  data: StudentPortfolioTaskResource,
): StudentPortfolioTask => ({
  id: data.id,
  title: data.title,
  description: data.description,
  teacherInstructions: data.teacher_instructions ?? null,
  startDate: new Date(data.start_date),
  deadline: new Date(data.deadline),
  bannerImage: data.banner_image,
  status: data.status,
  tags: data.tags.map(studentTagFromDto),
  tagIds: data.tag_ids,
  lobCompetences: data.lob_competences,
  lobCompetenceIds: data.lob_competence_ids,
  skills: data.skills.map(studentSkillFromDto),
  skillIds: data.skill_ids,
  isRequired: data.is_required,
  attachmentRequired: data.attachment_required,
  allowTaskRatings: data.allow_task_ratings,
  assessmentModels: data.assessment_models?.[0] ?? null,
  attachments: data.attachments.map(mapAttachment),
  links: mapLinks(data.links),
  videos: mapVideos(data.videos),
  questions: data.questions.map(taskQuestionFromDto),
  user: data.user,
  owners: data.owners,
});
